import { render, staticRenderFns } from "./DonutChart07.vue?vue&type=template&id=c571f9a4&scoped=true&"
import script from "./DonutChart07.vue?vue&type=script&lang=js&"
export * from "./DonutChart07.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c571f9a4",
  null
  
)

export default component.exports